<ng-template #template let-row="row">
  <div class="flex--row">
    <span>{{ row?.quantity | agrNumber }}</span>
    <span *ngIf="row?.orderingInformation?.orderUnit">
      {{ 'unit.' + row.orderingInformation.orderUnit | translate }}
    </span>
  </div>
</ng-template>
